import React, { Component } from 'react'
import PropTypes from 'prop-types'
import decode from 'decode-html'
import Parser from 'html-react-parser'

import Button from '../Button'
import PopUp from '../PopUp'
import staticData from '../../config/staticData'

class Changelog extends Component {
  state = {
    isOpen: false,
  }

  onClick = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  render() {
    const { classes } = this.props

    return (
      <React.Fragment>
        <span onClick={this.onClick} className={classes.link}>
          {staticData.changelog.title}
        </span>

        {this.state.isOpen && (
          <PopUp className={classes.popup}>
            <h1 className={classes.heading}>{staticData.changelog.title}</h1>
            <div className={classes.main}>
              {/* Decode twice: once for '&amp;' and then for the rest */}
              {Parser(decode(decode(staticData.changelog.content)))}
            </div>

            <Button className={classes.button} onClick={this.onClick}>
              Close
            </Button>
          </PopUp>
        )}
      </React.Fragment>
    )
  }
}

Changelog.propTypes = {
  classes: PropTypes.shape({
    button: PropTypes.string,
    link: PropTypes.string,
    popup: PropTypes.string,
    heading: PropTypes.string,
    main: PropTypes.string,
  }),
}

export default Changelog
